import { Modal } from 'antd';
import { Trans } from 'react-i18next';

import { JobPostingActionModal } from './VacancyActions';

const DeleteVacancyModal: React.FC<JobPostingActionModal> = ({ jobPosting, ...props }) => {
  return (
    <Modal {...props}>
      <span>
        <Trans>
          Ao excluir uma vaga todos os registros dela também serão excluídos e não poderão mais ser
          recuperados. Tem certeza que deseja excluir a vaga
        </Trans>{' '}
        <strong>{jobPosting.name}</strong>?
      </span>
    </Modal>
  );
};

export default DeleteVacancyModal;
